import React, { useEffect } from 'react';
import { ErrorBoundary } from '@fiverr-private/ui_utils';
import { stats } from '@fiverr-private/obs';
import { BriefCreationDrawerComponent } from '../../components';
import {
  BriefCreationContextProviderProps,
  Rollouts,
  useBriefCreationContext,
} from '../../context/BriefCreationContext';
import { BriefCreationContextProvider } from '../../context';
import { METRICS_PREFIX } from '../../constants';
import { logger } from '../../utils/logger';

export interface BriefCreationDrawerWrapperProps
  extends Rollouts,
    Pick<
      BriefCreationContextProviderProps,
      'currency' | 'isOpen' | 'source' | 'initialPrompt' | 'onOpen' | 'enableEnhancedUx' | 'enableScreeningQuestions'
    > {
  setIsOpen: (isOpen: boolean) => void;
  onSuccess?: () => void;
}

const Drawer = ({ isOpen = false }: { isOpen?: boolean }) => {
  const { setIsOpen } = useBriefCreationContext();

  useEffect(() => {
    setIsOpen(isOpen);
  }, [isOpen, setIsOpen]);

  return <BriefCreationDrawerComponent />;
};

const onError = (error) => {
  logger.error(error, {
    description: 'Failed to lazy load BriefCreationDrawerWrapper',
  });
  stats.count(`${METRICS_PREFIX}.lazy_load_brief_creation_drawer_wrapper`, 'error');
};

const BriefCreationDrawerWrapper = ({
  currency,
  isOpen,
  setIsOpen,
  source,
  onSuccess,
  rollouts,
  initialPrompt,
  onOpen,
  enableEnhancedUx,
  enableScreeningQuestions,
}: BriefCreationDrawerWrapperProps) => (
  <ErrorBoundary onError={onError}>
    <BriefCreationContextProvider
      rollouts={rollouts}
      currency={currency}
      setIsOpen={setIsOpen}
      source={source}
      onSuccess={onSuccess}
      initialPrompt={initialPrompt}
      onOpen={onOpen}
      enableEnhancedUx={enableEnhancedUx}
      enableScreeningQuestions={enableScreeningQuestions}
    >
      <Drawer isOpen={isOpen} />
    </BriefCreationContextProvider>
  </ErrorBoundary>
);

export default BriefCreationDrawerWrapper;
